const IMG = "/images/ip/oneroomta";

const KST_OFFSET_MS = 9 * 60 * 60 * 1000;
const DAY_MS = 24 * 60 * 60 * 1000;

export const BIRTHDAY_MODAL = {
  image: `${IMG}/birthday-modal-kv.jpg`,
  imageAlt: "우진형 생일 축하 키비주얼",
  audio: `${IMG}/birthday-voice.wav`,
  title: "진형 생일 축하 기념 스페셜 보이스 메시지🎂",
  storageKey: "oneroomta:birthday-modal:hide-until",
  // 노출 기간 (KST).
  startMs: new Date("2026-06-27T00:00:00+09:00").getTime(),
  endMs: new Date("2026-07-05T23:59:59+09:00").getTime(),
} as const;

/** 다음 KST 자정의 UTC 타임스탬프 (= 오늘 KST 23:59:59 직후). */
export function nextKstMidnightMs(now: number = Date.now()): number {
  const kstNow = now + KST_OFFSET_MS;
  const kstDayStart = Math.floor(kstNow / DAY_MS) * DAY_MS;
  return kstDayStart + DAY_MS - KST_OFFSET_MS;
}

export function shouldShowBirthdayModal(now: number = Date.now()): boolean {
  if (now < BIRTHDAY_MODAL.startMs || now > BIRTHDAY_MODAL.endMs) return false;
  try {
    const raw = localStorage.getItem(BIRTHDAY_MODAL.storageKey);
    if (raw && now < Number(raw)) return false;
  } catch {
    // localStorage 차단 환경에서는 그냥 노출
  }
  return true;
}
